<template>
<v-container class="fill-height" style="display: block;" fluid>
    <v-window v-model="windowPage" style="width: 100%;" touchless>

        <v-window-item :key="0">
            <div id="ag-grid-container">
                <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                    :gridOptions="gridOptions"
                    @row-double-clicked="(params) => editCommonObject(params.data)"
                    :groupHeaders="true"
                    :rowHeight="40">
                </ag-grid-vue>
            </div>
            <v-btn color="#c42111" class="mt-3 mr-3" @click="newCommonObject" :disabled="lockSave" v-if="showGrid">New</v-btn>
        </v-window-item>

        <v-window-item :key="1">
            <fields-list v-if="windowPage == 1" :fieldsList="selectedCommonObjectClone.object_fields" :commonObject="selectedCommonObjectClone" :lockSave="lockSave" @save="saveFields" @back="onFieldEditCancel"></fields-list>
        </v-window-item>

        <v-window-item :key="2">
            <items-list v-if="windowPage == 2" :commonObject="selectedCommonObject" :lockSave="lockSave" @back="windowPage = 0"></items-list>
        </v-window-item>

        <v-dialog v-model="showCommonObjectEdit" max-width="80%" width="300px" persistent @keydown="(k) => {k.key == 'Escape' ? showCommonObjectEdit = false : null}">
            <common-object-edit :commonObject="selectedCommonObjectClone" v-if="showCommonObjectEdit" @save="saveCommonObject" @cancel="showCommonObjectEdit = false"></common-object-edit>
        </v-dialog>
    
    </v-window>
</v-container>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import FieldsList from "@/components/CommonObjects/FieldsList";
import ItemsList from "@/components/CommonObjects/ItemsList";
import CommonObjectEdit from "@/components/CommonObjects/CommonObjectEdit";
export default {
    name: 'CommonObjects',
    props: [''],
    components: {
        'ag-grid-vue': AgGridVue,
        FieldsList,
        ItemsList,
        CommonObjectEdit
    },
    data: () => ({
        showGrid: false,
        gridOptions: {},
        commonObjectsList: [],
        windowPage: 0,
        lockSave: false,
        selectedCommonObject: null,
        selectedCommonObjectClone: null,
        showCommonObjectEdit: false
    }),

    computed: {

    },

    methods: {
        getCommonObjectsList: function() {
            this.showGrid = false;
            let route = (TELSA.apiHost + "commonobjects/list");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.commonObjectsList = result.common_objects_list;
                //this.userResources = {usersList: result.users_list, permissionsList: result.permissions_list};
                this.buildAgGrid();
                TELSA.loading(false);
            });
        },

        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.commonObjectsList;
            this.gridOptions.columnDefs = this.createColumnDefs();
            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                //self.gridOptions.columnApi.autoSizeColumns();
                self.gridOptions.api.sizeColumnsToFit();
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport',
                    {
                        name: 'AI Analyser',
                        disabled: !self.$store.state.batchConfig.webapp_openai,
                        action: function() {
                            self.$store.commit('setAiAnalyzerContext', 'commonObjects');
                            self.$store.commit('setAiAnalyzerGridAPI', self.gridOptions.api);
                            self.$store.commit('setShowAIAnalyzer', true);
                        },
                        icon: `<i data-v-10101010101="" aria-hidden="true" class="v-icon notranslate mdi mdi-lightning-bolt theme--dark"></i>`
                    },
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: '', 
                    suppressSizeToFit: true,
                    width: 160, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            this.eGui.innerHTML = `<span class="mdi mdi-pencil-circle common-object-action" style="cursor: ${self.lockSave ? 'default' : 'pointer'}; color: ${self.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                                <span class="mdi mdi-delete-circle common-object-action" style="cursor: ${self.lockSave ? 'default' : 'pointer'}; color: ${self.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                                <span title="Edit Fields" class="mdi mdi-checkbox-multiple-marked common-object-action" style="cursor: pointer; color: #c42111; font-size: 20pt" />
                                <span title="Edit Items" class="mdi mdi-format-list-bulleted-square common-object-action" style="cursor: pointer; color: #c42111; font-size: 20pt" />`;
                            
                            this.editButtonHandler = this.editButtonHandler.bind(this);
                            this.deleteButtonHandler = this.deleteButtonHandler.bind(this);
                            this.fieldsButtonHandler = this.fieldsButtonHandler.bind(this);
                            this.itemsButtonHandler = this.itemsButtonHandler.bind(this);

                            this.editButton = this.eGui.querySelectorAll('.common-object-action')[0];
                            this.deleteButton = this.eGui.querySelectorAll('.common-object-action')[1];
                            this.fieldsButton = this.eGui.querySelectorAll('.common-object-action')[2];
                            this.itemsButton = this.eGui.querySelectorAll('.common-object-action')[3];

                            this.editButton.addEventListener('click', this.editButtonHandler);
                            this.deleteButton.addEventListener('click', this.deleteButtonHandler);
                            this.fieldsButton.addEventListener('click', this.fieldsButtonHandler);
                            this.itemsButton.addEventListener('click', this.itemsButtonHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        editButtonHandler(event) {
                            event.stopPropagation();
                            this.params.editFunction(this.params);
                        }
                        deleteButtonHandler(event) {
                            event.stopPropagation();
                            this.params.deleteFunction(this.params);
                        }
                        fieldsButtonHandler(event) {
                            event.stopPropagation();
                            this.params.fieldsFunction(this.params);
                        }
                        itemsButtonHandler(event) {
                            event.stopPropagation();
                            this.params.itemsFunction(this.params);
                        }
                        destroy() {
                            this.editButton.removeEventListener('click', this.editButtonHandler);
                            this.deleteButton.removeEventListener('click', this.deleteButtonHandler);
                            this.fieldsButton.removeEventListener('click', this.fieldsButtonHandler);
                            this.itemsButton.removeEventListener('click', this.itemsButtonHandler);
                        }
                    },
                    cellRendererParams: {
                        editFunction: (params) => {
                            if(!self.lockSave) {
                                this.editCommonObject(params.data);
                            }
                        },
                        deleteFunction: (params) => {
                            if(!self.lockSave) {
                                this.deleteCommonObjectClick(params.data);
                            }
                        },
                        fieldsFunction: (params) => {
                            this.editCommonObjectFields(params.data);
                        },
                        itemsFunction: (params) => {
                            this.editCommonObjectItems(params.data);
                        }
                    }
                },
                { 
                    headerName: 'Object Name', 
                    field: 'object_name', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Description', 
                    field: 'object_description', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Fields', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.object_fields.length;
                    }
                },
                { 
                    headerName: 'Items', 
                    field: 'object_items', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
            ];
            return columnDefs;
        },

        editCommonObject: function(commonObject) {
            if(this.lockSave) {
                return;
            }
            this.selectedCommonObjectClone = JSON.parse(JSON.stringify(commonObject));
            this.showCommonObjectEdit = true;
        },

        saveCommonObject: function(commonObject) {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "commonobjects/edit");
            if(commonObject.object_id == 0) {
                route = (TELSA.apiHost + "commonobjects/add");
            }
            this.$http.post(route, {args: {commonObject: commonObject}}).then(response => {
                let result = response.body;
                this.showCommonObjectEdit = false;
                this.selectedCommonObjectClone = null;
                this.$store.commit('setIsDirty', false);
                this.getCommonObjectsList();
            });
        },

        deleteCommonObjectClick: function(commonObject) {
            this.$store.commit('showConfirmModal', {
                title: 'Delete Common Object',
                message: `This operation will delete this common object, and remove this object from all sites. Are you sure you want to do this?`,
                type: 'delete',
                hideCancel: false,
                confirmAction: () => this.deleteCommonObject(commonObject)
            });
        },

        deleteCommonObject: function(commonObject) {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "commonobjects/delete");
            this.$http.post(route, {args: {commonObjectId: commonObject.object_id}}).then(response => {
                let result = response.body;
                this.getCommonObjectsList();
            });
        },

        newCommonObject: function() {
            this.selectedCommonObjectClone = {
                object_description: "",
                object_fields: [],
                object_id: 0,
                object_items: 0,
                object_name: ""
            };
            this.showCommonObjectEdit = true;
        },

        editCommonObjectFields: function(commonObject) {
            this.selectedCommonObject = commonObject;
            this.selectedCommonObjectClone = JSON.parse(JSON.stringify(commonObject));
            this.windowPage = 1;
        },

        saveFields: function() {
            TELSA.loading(true);
            let deletedObjectFields = [];
            for(let initialField of this.selectedCommonObject.object_fields) {
                if(!this.selectedCommonObjectClone.object_fields.some(f => f.field_id == initialField.field_id)) {
                    deletedObjectFields.push({field_id: initialField.field_id, object_id: -1});
                }
            }
            let route = (TELSA.apiHost + "commonobjects/fields");
            this.$http.post(route, {args: {fields: (this.selectedCommonObjectClone.object_fields.concat(deletedObjectFields))}}).then(response => {
                let result = response.body;
                this.$store.commit('setIsDirty', false);
                TELSA.loading(false);
                this.windowPage = 0;

                let index = this.commonObjectsList.findIndex(co => co.object_id == this.selectedCommonObjectClone.object_id);
                this.commonObjectsList[index].object_fields = this.selectedCommonObjectClone.object_fields;
                this.getCommonObjectsList();
            });
        },

        onFieldEditCancel: function() {
            if(this.$store.state.isDirty) {
                this.$store.commit('showConfirmModal', {
                    title: 'Are you sure?',
                    message: 'Are you sure you want to abandon your changes without saving?',
                    type: 'warning',
                    confirmAction: () => {
                        this.$store.commit('setIsDirty', false); 
                        this.windowPage = 0; 
                        this.selectedCommonObject = null;
                        this.selectedCommonObjectClone = null;
                    }
                });
            }
            else {
                this.windowPage = 0;
                this.selectedCommonObject = null;
                this.selectedCommonObjectClone = null;
            }
        },

        editCommonObjectItems: function(commonObject) {
            if(commonObject.object_fields.length == 0) {
                this.$store.commit('showConfirmModal', {
                    title: 'No Fields Defined',
                    message: 'Fields must be defined before items can be added.',
                    type: 'warning',
                    hideCancel: true,
                    confirmAction: () => {return;}
                });
                return;
            }
            this.selectedCommonObject = commonObject;
            this.windowPage = 2;
        },

    },

    mounted() {
        // Permissions Check
        let permission = TELSA.checkPermission(this.$store.state.user, 'admin/sitebook');
        if(!permission) {
            let self = this;
            this.$store.commit('insufficientPermissions', {
                confirmAction: function(){self.getCommonObjectsList()}
            });
            this.lockSave = true;
            return;
        }

        let lockName = `edit_sitebook`;
        this.$store.dispatch('getLock', lockName).then(lockOwner => {
            this.getCommonObjectsList().then(v => {
            if(lockOwner) {
                // Disable save and let user know page is locked!
                this.lockSave = true;
                this.$store.commit('showConfirmModal', {
                title: 'Lock Warning',
                message: `The Site Book is already locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>. You cannot save any changes at this time.`,
                type: 'warning',
                hideCancel: true,
                confirmAction: function(){}
                });
            }
            });
        });
    }

  
};
</script>

<style scoped>

    .data-container {
        display: block;
        padding: 0;
    }

    #ag-grid-container {
        height: calc(100vh - 126px);
        width: 100%;
    }

</style>
